(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-review-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    document.querySelectorAll('[data-crev]').forEach(function (mount) {
      var section = mount.closest('[data-crev-section]');
      var list = mount.querySelector('[data-crev-list]');
      if (!section || !list) return;

      // Graceful empty state: a heading over nothing helps no one. Where the
      // section is only these cards (the landing page), hide it whole; on the
      // PDP the Judge.me app-block widget below keeps the section alive.
      var fail = function () {
        if (section.hasAttribute('data-crev-hide-section')) section.hidden = true;
        else mount.hidden = true;
      };

      var params = new URLSearchParams({
        shop_domain: mount.dataset.shopDomain,
        platform: 'shopify',
        page: '1',
        per_page: '6',
        sort_by: 'most-recent',
      });
      fetch('https://cdn.judge.me/reviews/all_reviews_js_based?' + params)
        .then(function (r) { if (!r.ok) throw new Error('jdgm ' + r.status); return r.json(); })
        .then(function (d) {
          var holder = document.createElement('div');
          // Rename the card classes (jdgm-rev* → s-crev*) BEFORE the nodes
          // hit the DOM: Judge.me's widget JS watches for `.jdgm-rev` cards
          // anywhere on the page and rebuilds any it finds (re-wraps the
          // header, empties the avatar initial), which shreds our layout.
          // Renamed, the cards are invisible to their JS and CSS both —
          // `.jdgm-star` stays for their icon-font glyphs.
          holder.innerHTML = (d.html || '')
            .replace(/jdgm-rev/g, 's-crev')
            .replace(/jdgm-divider-top/g, '');
          var cards = holder.querySelectorAll('.s-crev');
          if (!cards.length) { fail(); return; }
          // First paint replaces whatever Judge.me's own loader left behind
          // (a spinner) — this element is ours from here on.
          list.innerHTML = '';
          cards.forEach(function (card) { list.appendChild(card); });
          // Judge.me ships the date as a spinner element carrying the raw
          // timestamp in data-content; their JS would localize it, ours must.
          list.querySelectorAll('.s-crev__timestamp').forEach(function (el) {
            if (!el.classList.contains('jdgm-spinner')) return;
            var raw = el.getAttribute('data-content') || '';
            var parsed = new Date(raw.replace(' ', 'T').replace(' UTC', 'Z'));
            el.textContent = isNaN(parsed)
              ? raw.slice(0, 10)
              : parsed.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
            el.classList.remove('jdgm-spinner');
          });
        })
        .catch(fail);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    var root = document.getElementById('strum-review-list');
    var moreWrap = document.getElementById('strum-review-more');
    if (!root || !moreWrap) return;

    var page = 0;
    var perPage = 24;
    var body = null;

    function load() {
      var params = new URLSearchParams({
        shop_domain: root.dataset.shopDomain,
        platform: 'shopify',
        page: String(page + 1),
        per_page: String(perPage),
        sort_by: 'most-recent',
      });
      fetch('https://cdn.judge.me/reviews/all_reviews_js_based?' + params)
        .then(function (r) { if (!r.ok) throw new Error('jdgm ' + r.status); return r.json(); })
        .then(function (d) {
          page += 1;
          if (!body) {
            // First paint replaces whatever Judge.me's own setup left behind
            // (a spinner) — this element is ours from here on.
            root.innerHTML = '';
            body = document.createElement('div');
            body.className = 'jdgm-all-reviews__body';
            root.appendChild(body);
          }
          var holder = document.createElement('div');
          // Rename the card classes (jdgm-rev* → s-jrev*) BEFORE the nodes
          // hit the DOM: Judge.me's widget JS watches for `.jdgm-rev` cards
          // anywhere on the page and rebuilds any it finds (re-wraps the
          // header into jdgm-row-* divs, empties the avatar initial), which
          // shreds our layout. Renamed, the cards are invisible to their JS
          // and CSS both — `.jdgm-star` stays for their icon-font glyphs.
          holder.innerHTML = (d.html || '')
            .replace(/jdgm-rev/g, 's-jrev')
            .replace(/jdgm-divider-top/g, '');
          while (holder.firstChild) body.appendChild(holder.firstChild);
          // Judge.me ships the date as a spinner element carrying the raw
          // timestamp in data-content; their JS would localize it, ours must.
          body.querySelectorAll('.s-jrev__timestamp').forEach(function (el) {
            if (!el.classList.contains('jdgm-spinner')) return;
            var raw = el.getAttribute('data-content') || '';
            var parsed = new Date(raw.replace(' ', 'T').replace(' UTC', 'Z'));
            el.textContent = isNaN(parsed)
              ? raw.slice(0, 10)
              : parsed.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
            el.classList.remove('jdgm-spinner');
          });
          var shown = body.querySelectorAll('.jdgm-rev').length;
          var total = d.number_of_product_reviews || 0;
          moreWrap.hidden = !(shown < total);
        })
        .catch(function () {
          // No reviews is a §9-legal state; a broken fetch must not leave a
          // spinner or an empty band. Hide the widget area entirely.
          if (!body) root.closest('.s-revgrid__widget').hidden = true;
        });
    }

    moreWrap.querySelector('button').addEventListener('click', load);
    load();
  })();

  } catch(e) { console.error(e); }
})();
})();
